import React from 'react';
import { SimpleSelectionDto } from '../product-details/types';

interface ProductAttributeListprops {
	selections?: SimpleSelectionDto[];
	classNamePrefix?: string;
}

export default function ProductSelectionsList(props: ProductAttributeListprops) {
	const { selections = '' } = props;

	return (
		<ul className="roc-product-item-list">
			{selections !== undefined &&
				Array.isArray(selections) &&
				selections.length > 0 &&
				selections.map((selection, i) => (
					<li className="roc-product-item-list__item" key={i}>
						<span>
							<strong>{selection.name}</strong>:{' '}
						</span>
						<span>{selection.label}</span>
					</li>
				))}
		</ul>
	);
}
